<template>
	<page>
		<module>
			<view-list ref="view" work-type="69" dynamic-field :field-sort="false" :view-config="auth('b_material_report_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="创建时间">
							<c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
						</m-search-item>
						<m-search-item label="统计维度">
							<c-select name="dimension_id" v-model="dimension_id" :options="dimensionOption.active" :disable-options="dimensionOption.disabled" :clear="false">
								<template #option="{data, selected, disabled}">
									<select-option
										:name="data.name"
										:selected="selected"
										:vip="disabled"
									></select-option>
								</template>
							</c-select>
						</m-search-item>
						<m-search-item label="工单编号" v-if="dimension_id == 116 || dimension_id == 117 || dimension_id == 118 || dimension_id == 119">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="销售订单号" v-if="dimension_id == 120">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="工单状态" v-if="dimension_id == 116 || dimension_id == 117 || dimension_id == 118 || dimension_id == 119">
							<c-select name="work_states" :options="orderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="销售订单状态" v-if="dimension_id == 120">
							<c-select name="order_states" :options="salesOrderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="投料工序" v-if="dimension_id == 119">
							<c-select name="process_ids" async multiple @search="searchProcess" ></c-select>
						</m-search-item>
						<m-search-item label="物料编号" v-if="dimension_id == 118 || dimension_id == 119">
							<c-input name="material_product_code"></c-input>
						</m-search-item>
						<m-search-item label="物料名称" v-if="dimension_id == 118 || dimension_id == 119">
							<c-input name="material_product_name"></c-input>
						</m-search-item>
						<m-search-item label="物料规格" v-if="dimension_id == 118 || dimension_id == 119">
							<c-input name="material_product_spec"></c-input>
						</m-search-item>
					</m-search>
				</template>
				
				<template #operate>
					<c-button v-if="auth('b_material_report_export')" v-lock="lock('b_material_report_export')" prepend-icon="tf-export" @click="$refs.view.exportReportByViewId()">导出</c-button>
				</template>
				
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			let now = new Date();
			return {
				defaultSearchData: {
					dimension_id: 116,
					work_states: [1, 2, 3],
					start_date: new Date(now.getFullYear(), now.getMonth(), now.getDate()-6).format('yyyy-MM-dd'),
					end_date: new Date().format('yyyy-MM-dd')
				},
				dimension_id: 116
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['salesOrderStateDic', 'orderStateDic', 'auditStateDic']),
			...mapGetters(['freeEdition']),

			dimensionOption() {
				let options = [{
					name: '产品',
					value: 116
				}, {
					name: '产品+工单',
					value: 117
				}, {
					name: '产品+销售订单',
					value: 120
				},{
					name: '产品+用料',
					value: 118
				}, {
					name: '产品+工单+用料',
					value: 119
				}];

				return {
					active: options,
					disabled: this.freeEdition ? options.filter(item => item.name.includes('+')).map(item => item.value) : []
				}
			}
		},

		methods: {
			/*******搜索【工序】下拉框信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>